<template>
  <v-container>
    <v-card class="pa-4" max-width="1200">
      <v-card-title>Create Strategy</v-card-title>
      <v-card-text>
        <v-form ref="formRef" class="pa-2" @submit.prevent="submitForm">
          <v-row>
            <!-- Form fields remain unchanged -->
            <v-col cols="2">
              <v-menu v-model="startMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                <template #activator="{ props }">
                  <v-text-field v-bind="props" :model-value="formattedStartDate" label="Start Date" readonly dense
                    clearable required @click:clear="clearStartDate" />
                </template>
                <v-date-picker v-model="startDateRaw" color="primary" @update:model-value="startMenu = false" />
              </v-menu>
            </v-col>
            
            <v-col cols="2">  
              <v-text-field v-model="form.niftyLevelAtStart" label="Nifty Level" type="number" required />
            </v-col>
            
            <v-col cols="3">
              <v-text-field v-model="form.strategyName" label="Strategy Name" required />
            </v-col>
            
            <v-col cols="2">
              <v-select v-model="form.strategyType" :items="strategies" label="Strategy Type" required />
            </v-col>
            
            <v-col cols="3">
              <v-btn 
                type="submit" 
                color="primary" 
                :loading="submitting"
                :disabled="submitting"
              >
                <template v-slot:loader>
                  <v-progress-circular indeterminate size="24"></v-progress-circular>
                </template>
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const formRef = ref(null)
const submitting = ref(false)

// Date picker and form logic
const startDateRaw = ref(null)
const startMenu = ref(false)
const formattedStartDate = computed(() => formatDDMMYYYY(startDateRaw.value))

const form = ref({
  startDate: '',
  niftyLevelAtStart: '',
  strategyName: '',
  strategyType: ''
})

const strategies = ['M1', 'M2', 'DCE', 'QTRY', 'DELTA_MGMT', 'NEGATIVE_RATIO', 'SIDESWAYS', "POSTIVE"]

function formatDDMMYYYY(date) {
  if (!date) return ''
  const d = new Date(date)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}/${month}/${year}`
}

function clearStartDate() {
  startDateRaw.value = null
}

const submitForm = async () => {
  const isValid = await formRef.value?.validate?.()
  if (isValid !== false) {
    submitting.value = true
    form.value.startDate = formattedStartDate.value
    
    try {
      await store.dispatch('trades/createTrade', form.value)
      // Show loader for at least 1 second for better UX
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } catch (err) {
      console.error(err)
      submitting.value = false
    }
  }
}
</script>